<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="800px">
      <div class="rowDiv contentCenter">
        <div class="rounded-lg ml-2 pageTitle" style="width: 200px;">
          <v-btn @click='sendMessage'>test</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
      </div>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
// import Service from '../service/service'
import SignalR from '../SignalR'
export default {
  name: 'SignalR_test',
  data: () => ({
    controlPermission: [],
    rules: {
      content: [v => !!v || 'Required']
    },
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    var user = this.$store.getters.getUser
    // console.log(user)
    SignalR.init(JSON.parse(user).userId)
    SignalR.start()
    // SignalR.on('ReceiveHomePageMessage')
    SignalR.onreconnected()
    this.$emit('setAppbar', { isHide: false })
  },
  watch: {
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
  },
  created: function () {
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    sendMessage() {
      SignalR.invoke('SendNotify','bar',false,1)
    }
  }
}
</script>
